import React from 'react';
import PropTypes from 'prop-types';

import BasicInput from '../form-elements/BasicInput';
import CountryList from '../standard-value-lists/CountryList';
import StateList from '../standard-value-lists/StateList';
import HiddenInput from '../form-elements/HiddenInput';
import TypeAheadInput from '../form-elements/TypeAheadInput';
import countryData from '../../resources/countryKey.json';

class AddressInput extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			...props,
			showStateList: this.showStateList(props.countryValue),
			isValidated: false,
			mailabilityScore: 0,
		};

		this.handleCountryChange = this.handleCountryChange.bind(this);
		this.validateAddress = this.validateAddress.bind(this);

		this.addressValidationChecks = [];
	}

	showStateList(countryValue) {
		return countryValue === 'United States';
	}
	handleNewProps(prevProps) {
		const stateUpdate = {};
		Object.keys(AddressInput.propTypes).forEach((key) => {
			if (prevProps[key] !== this.props[key]) {
				stateUpdate[key] = this.props[key];
			}
		});
		if (Object.keys(stateUpdate).length > 0) {
			this.setState(stateUpdate);
		}
	}
	componentDidUpdate(prevProps) {
		this.handleNewProps(prevProps);
	}

	handleCountryChange(value) {
		this.setState({ showStateList: this.showStateList(value) }, () => {
			this.validateAddress(value);
		});
	}

	validateAddress(value) {
		setTimeout(async () => {
			const street1 = this.street1Input.props.value || '';
			const street2 = this.street2Input.props.value || '';
			const city = this.cityInput.props.value || '';
			const country = this.countryList.props.value || '';
			const state = this.stateInput.props.value || '';
			const zip = this.zipInput.props.value || '';

			const addressComplete = !!street1 && !!city && !!country && !!state && !!zip;

			let isValidated = false;
			let mailabilityScore = 0;
			if (addressComplete) {
				let data;
				const singleLine = `${street1} ${street2}, ${city}, ${state}. ${zip}, ${country}`;

				const cacheLookup = this.addressValidationChecks.filter((entry) => entry.address === singleLine)[0];
				if (!cacheLookup) {
					const cacheEntry = { address: singleLine };
					this.addressValidationChecks.push(cacheEntry);
					const url = `https://webnode.esri.com/3014/idq/validateaddress?address=${singleLine}`;

					const res = await fetch(url);
					data = await res.json();

					cacheEntry.data = data;
				} else {
					data = cacheLookup.data;
				}
				if (data.IsSuccess) {
					if (data.Address.length === 1) {
						const address = data.Address[0];
						isValidated =
							address.AddressLine1.toLowerCase() === street1.toLowerCase() &&
							address.City.toLowerCase() === city.toLowerCase() &&
							address.Postalcode.toLowerCase() === zip.toString().toLowerCase() &&
							address.State.toLowerCase() === state.toLowerCase();
						if (isValidated) {
							mailabilityScore = address.MailabilityScore;
						}
					}
				}
			}
			this.setState({ isValidated, mailabilityScore });

			if (this.props.onChange) {
				this.props.onChange({
					street1,
					street2,
					city,
					country,
					state,
					zip,
				});
			}
		}, 1);
	}

	async getAddrSuggestions(value) {
		// Can be async too!
		const suggestions = await fetch(`https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?&f=json&text='${value}'`);
		const data = await suggestions.json();
		const options = data.suggestions.map((item) => ({ ...item, value: item.text }));
		return options;
	}
	async getPostalSuggestions(value) {
		// Can be async too!
		const suggestions = await fetch(`https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?category=Postal&f=json&text='${value}'`);
		const data = await suggestions.json();
		const options = data.suggestions.map((item) => ({ ...item, value: item.text }));
		return options;
	}
	async findAddressCandidates(value, item, type) {
		const canidates = await fetch(
			`https://webnode.esri.com/3014/webappsproxy/OAuth?http://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates?&f=json&outFields=*&SingleLine=${encodeURI(
				value
			)}&magicKey=${item.magicKey}`
		);
		const data = await canidates.json();
		const atts = data.candidates[0].attributes;
		this.setState({ addr_geocode_result: data });

		if (type === 'Address') {
			this.street1Input.props.setValue(atts.StAddr);
			this.setState(
				{
					street1Value: atts.StAddr,
					street2Value: atts.SubAddr,
					cityValue: atts.City,
					countryValue: countryData.find((country) => country.iso3 === atts.Country).display,
					stateValue: atts.RegionAbbr !== '' ? atts.RegionAbbr : atts.Region,
					zipValue: atts.Postal,
					showStateList: atts.Country === 'USA',
				},
				() => this.validateAddress()
			);
			if (this.props.onAddressGeocode) {
				this.props.onAddressGeocode(data);
			}
		}
		if (type === 'Postal') {
			this.zipInput.props.setValue(atts.Postal);
			this.setState(
				{
					cityValue: atts.City,
					countryValue: countryData.find((country) => country.iso3 === atts.Country).display,
					stateValue: atts.RegionAbbr !== '' ? atts.RegionAbbr : atts.Region,
					zipValue: atts.Postal,
					showStateList: atts.Country === 'USA',
				},
				() => this.validateAddress()
			);
			if (this.props.onPostalGeocode) {
				this.props.onPostalGeocode(data);
			}
		}
	}

	render() {
		return (
			<React.Fragment>
				<TypeAheadInput
					innerRef={(c) => (this.street1Input = c)}
					label={this.props.street1Label}
					optionalLabel={this.props.optionalLabel}
					name={this.props.street1Name}
					value={this.state.street1Value}
					required={this.props.required}
					showError={this.props.street1ShowError}
					errorMessage={this.props.street1ErrorMessage}
					onOptionSelected={async (value, item) => {
						this.findAddressCandidates(value, item, 'Address');
					}}
					onKeyPress={this.getAddrSuggestions}
				/>

				<BasicInput
					innerRef={(c) => (this.street2Input = c)}
					label={this.props.street2Label}
					optionalLabel={this.props.optionalLabel}
					name={this.props.street2Name}
					value={this.state.street2Value}
					required={false}
					showError={this.props.street2ShowError}
					errorMessage={this.props.street2ErrorMessage}
					onChange={this.validateAddress}
				/>
				<TypeAheadInput
					innerRef={(c) => (this.zipInput = c)}
					label={this.props.zipLabel}
					optionalLabel={this.props.optionalLabel}
					name={this.props.zipName}
					value={this.state.zipValue}
					required={this.props.required}
					showError={this.props.zipShowError}
					errorMessage={this.props.zipErrorMessage}
					onChange={this.validateAddress}
					onOptionSelected={async (value, item) => {
						this.findAddressCandidates(value, item, 'Postal');
					}}
					onKeyPress={this.getPostalSuggestions}
				/>
				<BasicInput
					innerRef={(c) => (this.cityInput = c)}
					label={this.props.cityLabel}
					optionalLabel={this.props.optionalLabel}
					name={this.props.cityName}
					value={this.state.cityValue}
					required={this.props.required}
					showError={this.props.cityShowError}
					errorMessage={this.props.cityErrorMessage}
					onChange={this.validateAddress}
				/>
				<CountryList
					innerRef={(c) => (this.countryList = c)}
					label={this.props.countryLabel}
					optionalLabel={this.props.optionalLabel}
					name={this.props.countryName}
					value={this.state.countryValue}
					required={this.props.required}
					showError={this.props.countryShowError}
					errorMessage={this.props.countryErrorMessage}
					onChange={this.handleCountryChange}
				/>
				{this.state.showStateList ? (
					<StateList
						innerRef={(c) => (this.stateInput = c)}
						label={this.props.stateLabel}
						optionalLabel={this.props.optionalLabel}
						name={this.props.stateName}
						value={this.state.stateValue}
						required={this.props.required}
						showError={this.props.stateShowError}
						errorMessage={this.props.stateErrorMessage}
						onChange={this.validateAddress}
					/>
				) : (
					<BasicInput
						innerRef={(c) => (this.stateInput = c)}
						label={this.props.stateLabel}
						optionalLabel={this.props.optionalLabel}
						name={this.props.useSeparateProvinceProp && this.props.provinceName ? this.props.provinceName : this.props.stateName}
						value={this.props.useSeparateProvinceProp && this.props.provinceName ? this.state.provinceValue : this.props.stateValue}
						required={this.props.required}
						showError={this.props.stateShowError}
						errorMessage={this.props.stateErrorMessage}
						onChange={this.validateAddress}
					/>
				)}

				{this.state.isValidated && (
					<React.Fragment>
						<HiddenInput name="Postal_Address_Mailability" value={this.state.mailabilityScore} />
						<HiddenInput name="Address_Validation_Date" value={new Date().toString()} />
						<HiddenInput name="Addr_GeoCode_Result" value={this.state.addr_geocode_result} />
						<HiddenInput name="Postal_GeoCode_Result" value={this.state.postal_geocode_result} />
					</React.Fragment>
				)}
			</React.Fragment>
		);
	}
}

AddressInput.propTypes = {
	optionalLabel: PropTypes.string,
	street1Label: PropTypes.string,
	street1Name: PropTypes.string,
	street1Value: PropTypes.string,
	street1ShowError: PropTypes.bool,
	street1ErrorMessage: PropTypes.string,
	street2Label: PropTypes.string,
	street2Name: PropTypes.string,
	street2Value: PropTypes.string,
	street2ShowError: PropTypes.bool,
	street2ErrorMessage: PropTypes.string,
	cityLabel: PropTypes.string,
	cityName: PropTypes.string,
	cityValue: PropTypes.string,
	cityShowError: PropTypes.bool,
	cityErrorMessage: PropTypes.string,
	countryLabel: PropTypes.string,
	countryName: PropTypes.string,
	countryValue: PropTypes.string,
	countryShowError: PropTypes.bool,
	countryErrorMessage: PropTypes.string,
	stateLabel: PropTypes.string,
	stateName: PropTypes.string,
	stateValue: PropTypes.string,
	stateShowError: PropTypes.bool,
	stateErrorMessage: PropTypes.string,
	useSeparateProvinceProp: PropTypes.bool,
	provinceName: PropTypes.string,
	provinceValue: PropTypes.string,
	zipLabel: PropTypes.string,
	zipName: PropTypes.string,
	zipValue: PropTypes.string,
	zipShowError: PropTypes.bool,
	zipErrorMessage: PropTypes.string,
	required: PropTypes.bool,
	onChange: PropTypes.func,
	onPostalGeocode: PropTypes.func,
	onAddressGeocode: PropTypes.func,
};

export default AddressInput;
